<template>
  <div id="chg-pwd">
    <section class="section is-main-section">
      <div class="card">
        <div class="card-content">
          <p class="login-title is-size-5 has-text-weight-semibold">
            Submit your new password?
          </p>
          <br />
          <form @submit.prevent="onSubmit">
            <b-field label="New Password">
              <b-input v-model="form.new_password" name="password" required />
            </b-field>
            <b-field label="Confirm">
              <b-input
                v-model="form.conf_password"
                name="confirm_password"
                required
              />
            </b-field>
            <br />
            <b-field>
              <b-button
                :loading="isLoading"
                expanded
                native-type="submit"
                type="is-primary"
              >
                Submit
              </b-button>
            </b-field>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { changePassword } from '@/api/user'

import formMixin from '@/mixins/form'
import validationMixin from '@/mixins/validation'

import { required, sameAs } from '@/utils/validation'

export default {
  name: 'Forgot',
  mixins: [formMixin, validationMixin],
  data() {
    return {
      isLoading: false,
      rules: {
        new_password: [required],
        conf_password: [required, sameAs(this, 'new_password')]
      },
      form: {
        new_password: null,
        conf_password: null
      }
    }
  },
  methods: {
    submit() {
      this.form.forgot_token = this.$route.query.fpkey
      return changePassword(this.form)
        .then(() => {
          this.$router.replace({ name: 'login' })
        })
    }
  }
}
</script>

<style lang="scss">
#chg-pwd {
  margin-top: -3.25rem;
  section.section {
    display: flex;
    height: 100vh;
    justify-content: center;
    align-items: center;

    .login-title {
      margin-bottom: 0.75em;
    }

    .card {
      width: 420px;
      align-items: center;
      box-shadow: 0 4px 25px 0 rgba(0, 0, 0, 0.1);
    }
  }
}
</style>
